export enum DetectorModes {
  BINARY = "BINARY",
  COUNT = "COUNT",
  MULTICHOICE = "MULTI_CLASS",
  TEXT_RECOGNITION = "TEXT",
  BOUNDING_BOX = "BOUNDING_BOX",
}

export const DetectorModesReadable = {
  [DetectorModes.BINARY]: "Binary",
  [DetectorModes.COUNT]: "Count",
  [DetectorModes.MULTICHOICE]: "Multiple Choice",
  [DetectorModes.TEXT_RECOGNITION]: "Text Recognition",
  [DetectorModes.BOUNDING_BOX]: "Bounding Boxes",
};

export const detectorModesOptions: { value: DetectorModes; label: string }[] = [
  { value: DetectorModes.BINARY, label: "Binary (Yes/No)" },
  { value: DetectorModes.COUNT, label: "Count" },
];
